import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "common/components/ui/Dialog";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import OnboardingVideoPlaceholderDesktopImage from "assets/images/onboarding-video-placeholder-desktop.png";
import OnboardingVideoPlaceholderMobileImage from "assets/images/onboarding-video-placeholder-mobile.png";

export default function OnboardingVideo() {
  const isDesktop = useTwBreakpoint("lg");

  return (
    <section className="overflow-hidden lg:p-3 lg:mb-2 lg:pl-6 flex justify-between rounded-3xl border border-black-200 bg-[url(/images/onboarding-video-bg.png)] bg-center bg-cover">
      <div className="max-lg:p-3 lg:py-3 flex flex-col gap-y-1.5 lg:w-[389px]">
        <h3 className="text-md-bold lg:text-xl-bold">
          Watch our 90-second product tour to get familiar with Aimfox
        </h3>

        <p className="max-lg:hidden text-sm text-black-500">
          Take a quick look at how Aimfox helps you attract and manage leads
          effortlessly - no integrations or setup needed
        </p>
      </div>

      <Dialog>
        <DialogTrigger>
          <div className="relative max-lg:w-[112px] size-full lg:p-1 lg:border border-purple-100 lg:rounded-2xl">
            <img
              src={
                isDesktop
                  ? OnboardingVideoPlaceholderDesktopImage
                  : OnboardingVideoPlaceholderMobileImage
              }
              alt="Onboarding Video Placeholder"
              className="size-full object-cover lg:rounded-lg lg:shadow-xl"
            />
          </div>
        </DialogTrigger>
        <DialogContent className="!p-0 aspect-video lg:w-[1000px] overflow-hidden">
          <iframe
            src="https://player.vimeo.com/video/1136025376?autoplay=1"
            title="Onboarding Video"
            className="object-cover size-full"
            height={900}
            width={1600}
            allow="autoplay; fullscreen"
          />
        </DialogContent>
      </Dialog>
    </section>
  );
}
